/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormGrid } from '../../../../../styles/layout/FormGrid';
import { Field, RequiredMark } from '../../../../../styles/forms/Field';
import InterviewerPicker from '../../components/InterviewerPicker';
import { MODALITY_OPTIONS } from '../../constants';

// ---------------------------------------------------------------------------
// Campos compartilhados de agendamento de entrevista (modalidade · entrevistador
// · data-hora). Presentational — o estado e o submit vivem no modal que o usa
// (agendar / editar / remarcar). `scheduledAt` é o valor do <input datetime-local>
// (a conversão pra ISO com offset acontece no submit do modal, via toIsoWithOffset).
// ---------------------------------------------------------------------------

const FieldError = styled.span`
   font-size: 11px;
   color: ${({ theme }) => theme?.colors?.danger ?? '#b71c1c'};
   margin-top: 2px;
`;

export default function InterviewScheduleFields({
   modality,
   onModality,
   interviewerId,
   onInterviewer,
   scheduledAt,
   onScheduledAt,
   disabled = false,
   errors = {},
}) {
   return (
      <FormGrid>
         <Field className="col-6">
            <label htmlFor="interview-modality">Modalidade</label>
            <select
               id="interview-modality"
               value={modality}
               onChange={(e) => onModality(e.target.value)}
               disabled={disabled}
            >
               {MODALITY_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                     {option.label}
                  </option>
               ))}
            </select>
         </Field>

         <Field className="col-6">
            <label htmlFor="interview-datetime">
               Data e hora
               <RequiredMark>*</RequiredMark>
            </label>
            <input
               id="interview-datetime"
               type="datetime-local"
               value={scheduledAt}
               onChange={(e) => onScheduledAt(e.target.value)}
               disabled={disabled}
               aria-invalid={!!errors.scheduled_at || undefined}
            />
            {errors.scheduled_at && (
               <FieldError>{errors.scheduled_at}</FieldError>
            )}
         </Field>

         <Field className="col-12">
            <label htmlFor="interview-interviewer">
               Entrevistador (opcional)
            </label>
            <InterviewerPicker
               id="interview-interviewer"
               value={interviewerId}
               onChange={onInterviewer}
               disabled={disabled}
            />
            {errors.interviewer_user_id && (
               <FieldError>{errors.interviewer_user_id}</FieldError>
            )}
         </Field>
      </FormGrid>
   );
}

InterviewScheduleFields.propTypes = {
   modality: PropTypes.string.isRequired,
   onModality: PropTypes.func.isRequired,
   interviewerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onInterviewer: PropTypes.func.isRequired,
   scheduledAt: PropTypes.string.isRequired,
   onScheduledAt: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
   errors: PropTypes.objectOf(PropTypes.string),
};
